import Decimal from "decimal.js";

export function fix2(data) {
  return Number(Number(data).toFixed(2));
}

export function calcJobsDiscounts(jobDescriptions = []) {
  if (!jobDescriptions) {
    return "0.00";
  }

  let allDiscounts = jobDescriptions
    .map((jd) => {
      // Filter for set prices which include the word "discount"
      let discounts = jd.setPriceList.filter((setPrice) => {
        if (setPrice?.name?.toLowerCase().includes("discount")) return true;
        return false;
      });

      // Only return the set prices which contain the word discount.
      return discounts;
    })
    // Flatten array of discounts
    .flat()
    // Add up all the discounts
    .reduce((acc, item) => {
      let itemPrice = new Decimal(item.price || 0);
      return acc.plus(itemPrice);
    }, new Decimal(0));

  return allDiscounts.toFixed(2);
}

export function calcSubcontractorProfit(value) {
  const total = new Decimal(value);
  const profit = total.times(0.25);
  const subcontractorFee = total.minus(profit);

  return [profit.toFixed(2), subcontractorFee.toFixed(2)];
}

//Labour Calculations//////////////////////////////////////

export function calcJobSetPrices(jobDescription, vat) {
  // If vat is applied. We need to calculate the new price of the set items (pre-vat)
  // and sum these values. If no vat is applied, then just sum as normal
  if (!jobDescription) return "0.00";

  let setPrice = new Decimal(0);

  if (jobDescription?.setPriceList) {
    setPrice = jobDescription.setPriceList.reduce((acc, item) => {
      const quantity = new Decimal(item.quantity || 0);
      let itemPrice = new Decimal(item.price || 0);

      // if (vat) {
      //   // If vat mode on: calculate and use pre vat price for the item
      //   itemPrice = itemPrice.dividedBy(1.2);
      // }

      const price = new Decimal(itemPrice || 0);

      return acc.plus(quantity.times(price));
      // return Number(a) + Number(b.quantity) * Number(b.price);
    }, new Decimal(0));
  }

  return setPrice.toFixed(2);
}

export function calcJobLabour(jobDescription, vat) {
  if (!jobDescription) return "0.00";
  let { operatives = [] } = jobDescription;

  let ratePerHour = new Decimal(jobDescription.ratePerHour || 0);
  let hours = new Decimal(jobDescription.hours || 0);
  let jobOpRate = new Decimal(0);

  // if (vat) {
  //   ratePerHour = ratePerHour.dividedBy(1.2);
  // }

  for (let id in operatives) {
    let op = new Decimal(operatives[id]);
    jobOpRate = jobOpRate.plus(op);
  }

  // Need to keep the job op rate because of older timesheets that used it.
  let labourCost = ratePerHour.times(hours).times(jobOpRate);

  return labourCost.toFixed(2);

  // Before Decimal
  // if (!jobDescription) return "0.00";
  // let { ratePerHour = 0, hours = 0, operatives = [] } = jobDescription;
  // let jobOpRate = 0;

  // for (let id in operatives) {
  //   jobOpRate += Number(operatives[id]);
  // }

  // let labourCost = Number(ratePerHour) * Number(hours) * Number(jobOpRate);
  // return labourCost.toFixed(2);
}

// Rate (40) * OpRate (1.75)
/*

Rate Object:
accessId: int
createdBY: firebase uid
description: "Description of the rate"
name: "Rate Name"
ratePerHour: int
secondaryRate: int
uid: firebase uid




*/

export function calcJobSetPricesAndLabour(jobDescription, vat) {
  if (!jobDescription) return "0.00";

  let jobLabourCost = new Decimal(calcJobLabour(jobDescription, vat) || 0);
  let jobSetPriceCost = new Decimal(calcJobSetPrices(jobDescription, vat) || 0);
  let jobTotalCost = jobLabourCost.plus(jobSetPriceCost);

  return jobTotalCost.toFixed(2);
}

export function calcJobsLabour(jobDescriptions = [], vat) {
  if (!jobDescriptions) {
    return "0.00";
  }

  let jobsLabourCost = jobDescriptions
    .map((jd) => calcJobLabour(jd, vat))
    .reduce((acc, jdLabourCost) => {
      let jobLabourCost = new Decimal(jdLabourCost || 0);
      return acc.plus(jobLabourCost);
    }, new Decimal(0));

  return jobsLabourCost.toFixed(2);

  // Before decimal
  // if (!jobDescriptions) {
  //   return "0.00";
  // }

  // let jobsLabourCost = jobDescriptions.map(calcJobLabour).reduce((acc, jdLabourCost) => {
  //   return Number(Number(acc) + Number(jdLabourCost));
  // }, 0);

  // return jobsLabourCost.toFixed(2);
}

export function calcJobsSetPrices(jobDescriptions = [], vat) {
  if (!jobDescriptions) {
    return "0.00";
  }

  let setPricesCost = jobDescriptions
    .map((jd) => calcJobSetPrices(jd, vat))
    .reduce((acc, jdLabourCost) => {
      // return Number(Number(acc) + Number(jdLabourCost));
      return acc.plus(new Decimal(jdLabourCost || 0));
    }, new Decimal(0));

  return setPricesCost.toFixed(2);
}

export function calcJobsSetPricesAndLabour(jobDescriptions = [], vat) {
  if (!jobDescriptions) {
    return "0.00";
  }

  // Why isn't this working here !!!!!!!!!!!!!!!!!!!
  let jobsLabourCost = new Decimal(calcJobsLabour(jobDescriptions, vat) || 0);
  ////////////////////////////////////////////////////////////////////////////////

  let jobsSetPricesCost = new Decimal(calcJobsSetPrices(jobDescriptions, vat) || 0);

  let totalCost = jobsLabourCost.plus(jobsSetPricesCost);

  return totalCost.toFixed(2);

  // Before Decimal
  // if (!jobDescriptions) {
  //   return "0.00";
  // }

  // let jobsLabourCost = calcJobsLabour(jobDescriptions);
  // let jobsSetPricesCost = calcJobsSetPrices(jobDescriptions, vat);

  // let totalCost = Number(jobsLabourCost) + Number(jobsSetPricesCost);

  // return totalCost.toFixed(2);
}

///////////////////////////////////////////////////////////

//Materials Calculations //////////////////////////////////////

// export function calcJobMaterials(acc, item) {
//   let matsPrice = Number(item.itemRefPrice) * Number(item.quantity);
//   return Number(acc + matsPrice);
// }

export function calcJobMaterials(jobDescription) {
  if (!jobDescription) return ["0.00", "0.00", "0.00"];
  const { materials = [] } = jobDescription;

  let jobMaterialsBaseCost = materials.reduce((total, { itemRefPrice = 0, quantity = 0 }) => {
    //
    let price = new Decimal(itemRefPrice || 0);
    let qty = new Decimal(quantity || 0);

    let matsPrice = price.times(qty);
    return total.plus(matsPrice);
    //
    // Before Decimal
    // let matsPrice = Number(itemRefPrice) * Number(quantity);
    // return Number(total + fix2(matsPrice));
    //
  }, new Decimal(0));

  let jobMaterialsDifference = materials.reduce((total, { priceDifference = 0, quantity = 0 }) => {
    let priceDiff = new Decimal(priceDifference || 0);
    let qty = new Decimal(quantity || 0);

    let matsPriceDiff = priceDiff.times(qty);

    return total.plus(matsPriceDiff);
    //
    // Before Decimal
    // return fix2(total + Number(priceDifference) * Number(quantity));
    //
  }, new Decimal(0));

  let jobMaterialsCost = jobMaterialsBaseCost.plus(jobMaterialsDifference);
  // Before Decimal
  // let jobMaterialsCost = fix2(jobMaterialsBaseCost) + fix2(jobMaterialsDifference);
  //

  return [
    jobMaterialsCost.toFixed(2),
    jobMaterialsBaseCost.toFixed(2),
    jobMaterialsDifference.toFixed(2),
  ];
}

export function calcJobsMaterials(jobDescriptions = []) {
  if (!jobDescriptions) {
    return ["0.00", "0.00", "0.00"];
  }

  let jobsMaterialsCost = jobDescriptions
    .map((jd) => {
      return [
        new Decimal(calcJobMaterials(jd)[0] || 0),
        new Decimal(calcJobMaterials(jd)[1] || 0),
        new Decimal(calcJobMaterials(jd)[2] || 0),
      ];
    })
    .reduce(
      (price, acc) => {
        return [price[0].plus(acc[0]), price[1].plus(acc[1]), price[2].plus(acc[2])];
      },
      [new Decimal(0), new Decimal(0), new Decimal(0)],
    );

  // Returning [materialsTotal, materialsBase, materialsDifference]
  return [
    jobsMaterialsCost[0].toFixed(2),
    jobsMaterialsCost[1].toFixed(2),
    jobsMaterialsCost[2].toFixed(2),
  ];
  // Before decimal
  // if (!jobDescriptions) {
  //   return ["0.00", "0.00", "0.00"];
  // }
  // let jobsMaterialsCost = jobDescriptions
  //   .map((jd) => {
  //     return [
  //       Number(calcJobMaterials(jd)[0]),
  //       Number(calcJobMaterials(jd)[1]),
  //       Number(calcJobMaterials(jd)[2]),
  //     ];
  //   })
  //   .reduce(
  //     (price, acc) => {
  //       return [price[0] + acc[0], price[1] + acc[1], price[2] + acc[2]];
  //     },
  //     [0, 0, 0],
  //   );

  // // Returning [materialsTotal, materialsBase, materialsDifference]
  // return [
  //   jobsMaterialsCost[0].toFixed(2),
  //   jobsMaterialsCost[1].toFixed(2),
  //   jobsMaterialsCost[2].toFixed(2),
  // ];
}

// export function calcMarkupPercentage(basePrice = 0, priceWithAddOns = 0) {
//   let markupPercentage = (Number(basePrice) / Number(priceWithAddOns)) * 100;
//   return markupPercentage.toFixed(2);
// }

export function calcMaterialsVat(materialsPrice = 0) {
  // Might be useless function because it will be calculating vat on total materials I think.
  // Need to test with exports functions

  //Calculated single or multi materials as just takes in a number
  let price = new Decimal(materialsPrice);
  let vat = new Decimal(0); //0.2;
  let materialVat = vat.times(price);
  let total = price.plus(materialVat);

  return [materialVat.toFixed(2), total.toFixed(2)];

  // Before Decimal
  // //Calculated single or multi materials as just takes in a number
  // let price = Number(materialsPrice);
  // let vat = 0; //0.2;
  // let materialVat = vat * price;
  // let total = price + materialVat;

  // // console.log("Materials VAT", materialVat);

  // return [materialVat.toFixed(2), total.toFixed(2)];
}

// export function calcMaterialsWithAddOns(materialsPrice = 0, addOns = 0) {
//   //Calculated single or multi materials as just takes in a number
//   let percentage = Number(addOns) / 100;
//   let price = Number(materialsPrice);
//   let addOn = percentage * price;
//   let total = price + addOn;

//   return [addOn.toFixed(2), total.toFixed(2)];
// }

///////////////////////////////////////////////////////////////

//Labour and Materials /////////////////////////////////////////

export function calcJobTotal(job, vat = false) {
  let baseMaterialsPrice = new Decimal(calcJobMaterials(job)[0] || 0);

  let jobLabour = new Decimal(calcJobLabour(job, vat) || 0);
  let jobSetPrices = new Decimal(calcJobSetPrices(job, vat) || 0);
  let labourTotal = jobLabour.plus(jobSetPrices);

  let total = labourTotal.plus(baseMaterialsPrice);
  return total.toFixed(2);

  // Before Decimal
  // let baseMaterialsPrice = Number(calcJobMaterials(job)[0]);

  // let labourTotal = Number(calcJobLabour(job)) + Number(calcJobSetPrices(job));

  // let total = Number(labourTotal) + Number(baseMaterialsPrice);
  // return total.toFixed(2);
}

export function calcJobsTotalCost(jds = [], vat) {
  let [materialsPrice, materialsBase, materialsDifference] = calcJobsMaterials(jds).map(
    (v) => new Decimal(v || 0),
  );

  let labourTotal = new Decimal(calcJobsSetPricesAndLabour(jds, vat) || 0);

  let total = labourTotal.plus(materialsPrice);

  return [
    materialsPrice.toFixed(2),
    materialsBase.toFixed(2),
    materialsDifference.toFixed(2),
    labourTotal.toFixed(2),
    total.toFixed(2),
  ];

  // Before Decimal
  // let [materialsPrice, materialsBase, materialsDifference] = calcJobsMaterials(jds);
  // let labourTotal = Number(calcJobsSetPricesAndLabour(jds, vat));
  // let total = Number(labourTotal) + Number(materialsPrice);
  // return [
  //   Number(materialsPrice).toFixed(2),
  //   Number(materialsBase).toFixed(2),
  //   Number(materialsDifference).toFixed(2),
  //   labourTotal.toFixed(2),
  //   total.toFixed(2),
  // ];
}

// export function calcJobTotalWithAddOns(base = 0, addOn = 0) {
//   let baseMaterialsPrice = Number(base);
//   let addOnPercentage = Number(addOn);

//   let newMaterialPrice =
//     baseMaterialsPrice * (addOnPercentage / 100) + baseMaterialsPrice;

//   return newMaterialPrice.toFixed(2);
// }

// export function calcJobsTotalWithAddOns(jds, addOns) {
//   let baseMaterialsPrice = Number(calcJobsMaterials(jds)[0]);
//   let [materialsVat, materialsTotal] = calcMaterialsWithAddOns(
//     baseMaterialsPrice,
//     addOns
//   );

//   // let labourTotal = Number(calcJobsLabour(jds));
//   let labourTotal = Number(calcJobsSetPricesAndLabour(jds));

//   let total = Number(labourTotal) + Number(materialsTotal);

//   if (jds == null) return 0;

//   return total.toFixed(2);
// }

/////////////////////////////////////////////////////////////////

// let materialsPrice = materials.reduce((acc, item) => {
//   let matsPrice = Number(item.itemRefPrice) * Number(item.quantity);
//   return Number(acc + matsPrice);
//   //console.log("the total price is now:", matsPrice);
// }, 0);
// setTotal(materialsPrice.toFixed(2));

export function calcJobsHours(jobDescriptions = []) {
  if (!jobDescriptions) {
    return "0.00";
  }

  let hours = jobDescriptions.reduce((acc, { hours = 0 }) => {
    let hrs = new Decimal(hours || 0);
    return acc.plus(hrs);
  }, new Decimal(0));

  return hours.toFixed(2);

  // if (!jobDescriptions) {
  //   return "0.00";
  // }
  // // console.log("calc jobs labour", jobDescriptions);
  // let hours = jobDescriptions.reduce((acc, { hours = 0 }) => {
  //   return Number(Number(acc) + Number(hours));
  // }, 0);

  // return hours.toFixed(2);
}

// VAT ///////////////////////////////////////////////////////////

export function calcVatInclusive(price = 0) {
  let vatIncPrice = new Decimal(price);
  vatIncPrice = vatIncPrice.times(1.2);

  return vatIncPrice.toFixed(2);
}

export function calcVat(excludingVat = 0, vatActive = false) {
  const total = new Decimal(excludingVat);
  let vatPercentage = 0;

  if (vatActive) {
    vatPercentage = 0.2;
  }

  const vat = total.times(vatPercentage);
  const inc = total.add(vat);

  return [vat.toFixed(2), inc.toFixed(2)];
}

//////////////////////////////////////////////////////////////////

// Other /////////////////////////////////////////////////////////

export function calcCardFee(jobCost, cardFeePercentage, vat) {
  const total = new Decimal(jobCost || 0);
  let cardFee = total.times(cardFeePercentage);

  if (vat) {
    cardFee = cardFee.dividedBy(1.2);
  }

  return cardFee.toFixed(2);
}

export function calcLabourDifference(target, currentTotal, vat) {
  // Calculates difference between the target price and current total.
  // console.log("target", target);
  // console.log("current", currentTotal);
  // console.log("vat", vat);

  let targetPrice = new Decimal(target || 0);
  let total = new Decimal(currentTotal || 0);

  let difference = targetPrice.minus(total);

  if (vat) {
    difference = difference.dividedBy(1.2);
  }
  console.log("difference", difference);

  return difference.toFixed(6);
}

export function calcPreVatAmount(amount = 0) {
  let newAmount = new Decimal(amount);
  newAmount = newAmount.dividedBy(1.2);

  return newAmount.toFixed(6);
}

export function calcRateAmount(rate = 0, hours = 0, vat = false) {
  // Calculates the amount to show beside the rate section in jobDescription page
  let rateCost = new Decimal(rate || 0);
  const totalHours = new Decimal(hours || 0);

  // if (vat) {
  //   rateCost = rateCost.dividedBy(1.2);
  // }

  const rateAmount = rateCost.times(totalHours);

  return [rateCost.toFixed(6), rateAmount.toFixed(2)];
}

//////////////////////////////////////////////////////////////////
